import { useLang } from "@/i18n/LanguageContext";

const LangSwitch = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  const btn = (code, label) => (
    <button
      type="button"
      key={code}
      onClick={() => setLang(code)}
      aria-pressed={lang === code}
      aria-label={code === "en" ? "Switch to English" : "Cambiar a español"}
      data-testid={`lang-switch-${code}`}
      className={`p-1 transition-colors duration-300 ${
        lang === code ? "text-gold" : "text-ivory/50 hover:text-ivory"
      }`}
    >
      {label}
    </button>
  );
  return (
    <div
      className={`flex items-center gap-2 font-sans text-[11px] tracking-[0.25em] ${className}`}
      data-testid="lang-switch"
    >
      {btn("en", "EN")}
      <span className="text-ivory/30" aria-hidden="true">|</span>
      {btn("es", "ES")}
    </div>
  );
};

export default LangSwitch;
